import { useMemo } from "react";
import { FormSelectItem, ProvetMonthModel } from "../../../types";

export function useAvailableVeterinarians(provetMonth: ProvetMonthModel | null) {
  return useMemo((): FormSelectItem[] => {
    const vets = provetMonth?.veterinarians ?? [];
    if (vets.length) {
      return vets
        .filter((vet, index, array) => array.findIndex(v => v.id === vet.id) === index) // DistinctBy id
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
        .map(vet => ({
          description: vet.title,
          caption: vet.name || "",
          value: vet.id?.toString() || ""
        }));
    }
    return [];
  }, [provetMonth]);
}
